import React, { useState, useRef, useEffect } from 'react';
import close from '../../assets/icons/close.svg';

const BottomSheet = ({ url, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);
  const ref = useRef(null);

  useEffect(() => {
    const currentRef = ref.current;
    let startY = 0;
    let endY = 0;

    const onTouchStart = (e) => {
      startY = e.touches[0].clientY;
    };

    const onTouchMove = (e) => {
      endY = e.touches[0].clientY;
    };

    const onTouchEnd = () => {
      if (startY - endY > 50) {
        setIsVisible(false);
        setTimeout(() => onClose(), 300);
      }
    };

    currentRef.addEventListener('touchstart', onTouchStart);
    currentRef.addEventListener('touchmove', onTouchMove);
    currentRef.addEventListener('touchend', onTouchEnd);

    return () => {
      currentRef.removeEventListener('touchstart', onTouchStart);
      currentRef.removeEventListener('touchmove', onTouchMove);
      currentRef.removeEventListener('touchend', onTouchEnd);
    };
  }, [onClose]);

  return (
    <div 
      ref={ref}
      style={{
        position: 'fixed',
        bottom: isVisible ? 0 : '-100%',
        left: 0,
        width: '100%',
        height: '66vh',
        transition: 'bottom 0.3s ease-in-out',
        backgroundColor: 'white',
        zIndex: 1000,
        overflow: 'hidden',
        borderRadius: '10px 10px 0 0',
      }}
    >
      <iframe src={url} style={{ width: '100%', height: '100%' }} title="content"></iframe>
      <button onClick={() => {
        setIsVisible(false);
      }} style={{ position: 'absolute', top: '10px', right: '10px' }}>
          <img
                src={close}
                alt="close"
                height={24}
                width={24}
                style={{ height: "24px" , margin: '3px' }}
                className="cursor-pointer"
              ></img>
      </button>
    </div>
  );
};

export default BottomSheet;
